import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import {
  load as loadIntercom,
  boot as bootIntercom,
  update as updateIntercom
} from "../intercom";

export class Analytics extends Component {
  constructor(props) {
    super(props);
    this.sendPageView = this.sendPageView.bind(this);
  }
  componentDidMount() {
    loadIntercom();
    let options = {
      hide_default_launcher: true,
      user_id: this.props.user_id,
      companies: [ { company_id: localStorage.getItem('lastSiteUUID') } ]
    };
    bootIntercom(options);
    this.sendPageView(this.props.location);
    this.props.history.listen(this.sendPageView);
  }
  render() {
    return this.props.children;
  }
  sendPageView(location) {
    this.lastPathname = location.pathname;
    const page = this.props.basename ? `${this.props.basename}${location.pathname}` : location.pathname;
    // Send page view to Google Analytics
    gtag('event', 'page_view', { // eslint-disable-line no-undef
      page_path: page,
      send_to: 'G-7JR9JFDHCG'
    })
    // Send page view to Intercom
    updateIntercom();
    if (this.props.debug) {
      console.info(`Page view: ${page}`)
    }
  }
}
export default withRouter(Analytics);
